const ROLE_MAP = {
  employee: 'employee',
  manager: 'company_admin',
  admin: 'super_admin',
  company_admin: 'company_admin',
  super_admin: 'super_admin'
};

export const normalizeRole = (role) => ROLE_MAP[role] || 'employee';

const ROLE_LABELS = {
  employee: 'Çalışan',
  company_admin: 'Admin',
  super_admin: 'Süper Admin'
};

export const getRoleLabel = (role) => ROLE_LABELS[normalizeRole(role)];

export const hasAnyRole = (role, allowedRoles = []) => {
  const normalizedRole = normalizeRole(role);
  return allowedRoles.includes(normalizedRole);
};

export const hasPermission = (user, resource, action) =>
  (user?.customRoles || []).some((role) =>
    (role.permissions || []).some((permission) =>
      permission.resource === resource && permission.actions.some((item) => item === action || item === 'manage')
    )
  );
